export enum ActionTypes {
  "AUTH_LOGIN" = "AUTH_LOGIN",
  "VERIFY_AUTH" = "VERIFY_AUTH",
  "REFRESH_AUTH" = "REFRESH_AUTH",
  "VERIFY_TEMPORARY_TOKEN" = "VERIFY_TEMPORARY_TOKEN",
  "RESET_PASSWORD" = "RESET_PASSWORD",
  "DECONNEXION" = "DECONNEXION",
  "SET_VIEW" = "SET_VIEW"
}
